import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { SelectEnum } from '~/shared/components/select-fields/SelectEnum';

// Todo; temporary enum
export const enumPackageFormat = {
  NoPackage: 'NoPackage' as const,
  Bale: 'Bale' as const,
  Gaylord: 'Gaylord' as const,
  Drum: 'Drum' as const,
  Loose: 'Loose' as const,
  Pallet: 'Pallet' as const,
};

const formatLabel = (value: string) => {
  if (value === 'NoPackage') return 'No Package';
  return value;
};

export interface PackageFormatCellProps {
  value?: string | null;
  onChange: (value?: string) => void;
  disabled?: boolean;
  className?: string;
}

export const PackageFormatCell: React.FC<PackageFormatCellProps> = ({
  value,
  onChange,
  disabled = false,
  className,
}) => (
  <SelectEnum
    enumValue={enumPackageFormat}
    formatOptionLabel={formatLabel}
    value={value ?? undefined}
    onChange={onChange}
    isDisabled={disabled}
    className={cn('@PackageFormatCell', className)}
  />
);
